import { render } from "./SpinnerLoading.vue?vue&type=template&id=1f6a500b&scoped=true"
const script = {}

import "./SpinnerLoading.vue?vue&type=style&index=0&id=1f6a500b&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6a500b"]])

export default __exports__